import script from "./NotificationMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&setup=true&lang=js"

import "./NotificationMessage.vue?vue&type=style&index=0&id=1c8b0210&scoped=true&lang=scss"

import exportComponent from "../../../author/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c8b0210"]])

export default __exports__